module.exports = __webpack_public_path__ + "images/views-upsell/timeline.1df2ef6e7cfd3af8f75b.svg";